import script from "./ContactMe.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactMe.vue?vue&type=script&lang=ts&setup=true"

import "./ContactMe.vue?vue&type=style&index=0&id=1fbf2d35&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fbf2d35"]])

export default __exports__